import { FC } from 'react';
import { ButtonBrand } from 'components/ButtonBrand';
import { formatNumberAsCurrency } from 'helpers/utils';
import { ADMINS_ONLY, getIsFeatureOn } from 'helpers/featureFlags';
import { CandidateType } from '../Candidates/Candidates';
import { CustomLinkCopy } from '../CustomSplit/CustomLinkCopy';

interface Props {
  candidates: CandidateType[];
  selectedDonationAmount?: number;
  onClick: () => void;
}

export const Summary: FC<Props> = ({ candidates, selectedDonationAmount = 0, onClick }) => {
  const numCandidates = candidates.filter(c => c.isSelected).length;

  return (
    <div className="rec-summary-content">
      <div className="column">
        <span className="h4-text light-font">Your donation summary</span>
        <span className="body-text">
          <span className="semi-bold">{formatNumberAsCurrency(selectedDonationAmount)}</span> Total
          contribution amount
        </span>
        <span className="body-text">
          <span className="semi-bold">{numCandidates}</span> Recipients selected
        </span>
      </div>
      {numCandidates > 0 && (
        <div className="column">
          <ButtonBrand onClick={onClick}>Complete Donation</ButtonBrand>
          {getIsFeatureOn(ADMINS_ONLY) && <CustomLinkCopy candidates={candidates} />}
        </div>
      )}
    </div>
  );
};
